import ProfitLossReportPage from "./profit-loss-page";

export default ProfitLossReportPage